var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('site-title',{attrs:{"text":'Selected Works',"textDelay":0.5}}),_vm._v(" "),_c('text-block',{attrs:{"revealTransition":true}},[_vm._v("Check out some of the works I've done in the last few years.")])],1),_vm._v(" "),_c('work-list',{attrs:{"listType":"all"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('site-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e2b8023","hasScoped":true,"transformToRequire":{"video":"src","source":"src","vector":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Works.vue
// module id = gk9y
// module chunks = 0